import { optionTitle_reporting } from './ReportingOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isConsumer } from 'owa-session-store';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const ReportingOption: LazyOption = createLazyOption(
    {
        key: 'reportingOption',
        titleStringKey: optionTitle_reporting,
        searchTermsStringKey: optionTitle_reporting,
        isHidden: () => {
            return isConsumer() || IsShadowMailboxUser();
        },
    },
    lazyFullModule,
    m => m.default
);
export default ReportingOption;
